class WIfreeproduct extends HTMLElement{
    constructor(){
        super();
        document.addEventListener('cartAllProcessEnded',()=>{
            this.addFreeGift();
        });
    }
    // Add free gift 
    async addFreeGift(){
        let freeProPrice = this.querySelector('.WI_freeProductPrice').value * 100;
        let freeProductIDs = this.querySelectorAll('.WI_freeProductID');
        let hasFreeProduct = false;
        let formData = {'items':[]};
        let removeFormData =[];
        try {
            let cartRes = await fetch(window.Shopify.routes.root + 'cart.js');
            let cartData = await cartRes.json();
            console.log(freeProPrice);
            console.log(cartData.total_price);
            if (cartData.total_price >= freeProPrice) {
                for (let item of cartData.items) {
                    if (item.product_type === 'free') {
                        hasFreeProduct = true;
                        break;
                    }
                }
               
                if (hasFreeProduct == false) {
                    for (let id of freeProductIDs) {
                        let varid = id.value;
                        formData.items.push({'id': varid,'quantity': 1});
                    }
                
                    let addResponce = await fetch(window.Shopify.routes.root + 'cart/add.js', {
						method: 'POST',
						headers: {
							'Content-Type': 'application/json'
						},
						body: JSON.stringify(formData)
					});
                }
            }else{
              
                cartData.items.forEach((item)=>{
                    if(item.product_type === 'free'){
                        hasFreeProduct = true;
                        let key = item.key;
                        removeFormData.push({ 'id':key, 'quantity': 0 });
                    }
                });
                if (hasFreeProduct == true) {
                    for (const removeItem of removeFormData) {
                        try {
                            let updateResponse = await fetch(window.Shopify.routes.root + 'cart/change.js', {
                                method: 'POST',
                                headers: {
                                    'Content-Type': 'application/json'
                                },
                                body: JSON.stringify(removeItem)
                            });
                
                            if (updateResponse.ok) {
                                console.log(`Item ${removeItem.id} removed successfully`);
                                document.dispatchEvent(new CustomEvent('updateCart', {bubbles: true}));
                            } else {
                                console.error(`Failed to remove item ${removeItem.id}`);
                            }
                        } catch (error) {
                            console.error('Error:', error);
                        }
                };
                }
            }
        } catch (error) {
            console.log('Fetching cart data failed '+ error);
        }       
    }
}
customElements.define('wi-freeproduct', WIfreeproduct);
